import React, { useState } from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import Tooltip from "../components/Tooltip";
import "./DesarrolloWeb.css";
import ContactModal from "../components/ContactModal/ContactModal";

function DesarrolloWeb() {
  const [isModalOpen, setIsModalOpen] = useState(false);	
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <>
      <SEO
        title="Desarrollo Web & App | React, Next.js y soluciones modernas"
        description="Sitios & App rápidos, escalables y optimizados con tecnologías modernas."
        url="https://juancarlosmancharamos.ar/desarrollo-web"
      />

      <Menu />

      <HeroInner
        title="Desarrollo Web & App"
        subtitle="Rápidos y responsivos con React, Next.js y tecnologías modernas"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        {/* Contenedor interno para no romper tu clase .container global */}
        <div className="dev-inner-wrap">
          
          <div className="dev-header">
            <div className={`img-wrapper ${imgLoaded ? "loaded" : ""}`}>
              <img
                src="/images/webyapp.jpg"
                className="imagenprincipal"
                alt="Desarrollo Web y App en React y Next.js"
                onLoad={() => setImgLoaded(true)}
                loading="eager"
                decoding="async"
              />
            </div>
            
            {/* Restauramos la clase h2first aquí para que el texto suba y solape la imagen */}
            <div className="dev-intro-content h2first">
              <h2 className="dev-title">Desarrollo Web & App Profesional</h2>
              <p className="dev-lead">
                Desarrollo sitios web y aplicaciones modernas, rápidas y escalables utilizando 
                tecnologías líderes como <strong>React, Next.js y JavaScript avanzado</strong>. 
                Transformo ideas en soluciones digitales de alto impacto.
              </p>
              <p>
                Cada línea de código está pensada para cargar en milisegundos, adaptarse 
                perfectamente a cualquier dispositivo móvil o de escritorio, y generar 
                resultados tangibles: más tráfico orgánico, interacciones de calidad y mayores conversiones para tu negocio.
              </p>
            </div>
          </div>

          {/* Cuadrícula de Características con Iconos */}
          <div className="dev-features">
            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
              </div>
              <h3>Arquitectura Moderna</h3>
              <p>Desarrollo frontend avanzado con React y Next.js para aplicaciones rápidas, seguras y preparadas para escalar a futuro.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path></svg>
              </div>
              <h3>Rendimiento y SEO</h3>
              <p>Cumplimiento estricto de Core Web Vitals. Estructura semántica y carga ultra rápida para dominar los resultados de Google.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
              </div>
              <h3>Integración y CMS</h3>
              <p>Conexión fluida con WordPress, WooCommerce, PrestaShop y APIs de terceros para autogestión de contenidos sin perder velocidad.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle></svg>
              </div>
              <h3>Diseño a Medida</h3>
              <p>Sin plantillas genéricas. Interfaces únicas (UI/UX) que reflejan la identidad de tu marca y están optimizadas para la conversión.</p>
            </div>
          </div>

          {/* Banner de Llamada a la Acción (CTA) */}
          <div className="dev-cta-banner">
            <h3>¿Listo para llevar tu proyecto al siguiente nivel digital?</h3>
            <p>Hablemos sobre tu idea y evaluemos la mejor arquitectura web para potenciar tu negocio.</p>
            {/* Solución anti-errores: Botón en lugar de etiqueta 'a' */}
            <button onClick={() => setIsModalOpen(true)} className="dev-btn-primary" style={{border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}>
			  Solicitar Presupuesto
			</button>
          </div>
          
        </div>
      </section>

      <section id="abt-lnk" className="center-first">
        <div className="gp no-tpgp btm-spc130">
          <div className="container">
            <div className="skls-wrp2 ovrlp-60 text-center">
              <div className="skls-inr">
                <h2 itemProp="headline">
                  + servicios
                </h2>
              </div>
              <Services />
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
      <ChatBot />
      <Tooltip />
      <GlobalScripts />
	  <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        defaultService="Desarrollo Web y App" 
      />	  
    </>
  );
}

export default DesarrolloWeb;